import { Chart } from "chart.js";

export const masterWeek = {
  templateUrl: "admin/views/master-week.html",
  controller: "masterWeekCtrl",
  bindings: {
    patient: "<",
  },
};

export const caregiverTrainingCenter = {
  templateUrl:
    "admin/views/caregiverTrainingCenter.html",
  controller: "caregiverTrainingCenterCtrl",
  bindings: {
    caregiver: "<",
  },
};

export const caregiverTrainingCenterBundle = {
  templateUrl:
    "admin/views/caregiverTrainingCenterBundle.html",
  controller: "caregiverTrainingCenterBundleCtrl",
  bindings: {
    caregiver: "<",
    bundle: "<",
  },
};

export const caregiverTrainingCenterDueDate = {
  templateUrl:
    "admin/views/caregiverTrainingCenterDueDate.html",
  controller: "caregiverTrainingCenterDueDateCtrl",
  bindings: {
    caregiver: "<",
    bundle: "<",
    dueDate: "<",
  },
};

export const caregiverTrainingCenterInfoBundleDueDateHeader = {
  templateUrl:
    "admin/views/caregiverTrainingCenterInfoBundleDueDateHeader.html",
  controller: "caregiverTrainingCenterInfoBundleDueDateHeaderCtrl",
  bindings: {
    caregiver: "<",
    bundle: "<",
    dueDate: "<",
  },
};

export const nursingQuestion = {
  templateUrl: "admin/views/nursing-question.html",

  //! @ngInject
  controller: function (nursingMedicalStatisticsService, $timeout) {
    this.getPercentage = function (question, answer) {
      const total = this.getTotalCount(question);

      return Math.round((answer.count / total) * 100);
    };

    this.getTotalCount = function (question) {
      let sum = 0;

      for (const answer of question.answerStats) {
        sum += answer.count;
      }

      return sum;
    };

    this.$onInit = function () {
      var that = this;
      // show chart only if its a sub-question
      if (this.showChart) {
        $timeout(function () {
          that.setChart();
        });
      }
    };

    this.setChart = function () {
      const canvas = document.getElementById(
        `nursing-question-modal-chart-` + this.question.id
      );
      const ctx = canvas.getContext("2d");

      const chart = new Chart(
        ctx,
        nursingMedicalStatisticsService.getChartConfigByQuestion(this.question)
      );
    };
  },
  bindings: {
    question: "=",
    isInitialQuestion: "=",
    selectPatientsByAnswer: "&",
    showChart: "=",
  },
};
